<ticker-card
  [titleText]="'crmContacts.analytics.opportunities' | translate"
  [data]="data"
  [percentage]="20.3"
  icon="datatrending"
></ticker-card>
